const initInputs = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  rootEl.querySelectorAll('.form-element--icon').forEach((iconInput) => {
    const icon = iconInput.querySelector('.icon');
    const input = iconInput.querySelector('input');
    if (!icon || !input) return;

    if (input.type == 'password')
      icon.addEventListener('click', () => {
        iconInput.classList.toggle('active');
        input.type = input.type == 'password' ? 'text' : 'password';
      });
  });
};

export { initInputs };
